import React, { useEffect, useRef, useState } from 'react'
import './manager-activity-list.styles.scss';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobeAmericas } from '@fortawesome/free-solid-svg-icons';
import DetailedActivityList from '@/components/SHARED/detailed-activity-list/detailed-activity-list.component';
import { UseCloudFunction } from '@/utils/firebase.utils';
import { useSelector } from 'react-redux';
import { getRegsFromDb, getUniqueDocumentFromDb } from '@/utils/getDataFromDb';

const ManagerActivityList = ({ 
    gameData, 
    gameActivity, 
    playerList, 
    gameElements,
    gameManagers
}) => {

    const userProfile = useSelector(state => state.userData.userProfile);
    const [ activityToDisplay, setActivityToDisplay ] = useState([]);
    const [ orgMembers, setOrgMembers ] = useState([]);
    const navigate = useNavigate();
    const managerRef = useRef();

    useEffect(() => {
        if (!gameActivity) return;
        const avail = Object.values(gameActivity)
        // .filter(a => 
        //     a.display  === 'reward' || 
        //     a.display === 'playerActivity' || 
        //     a.display === 'purchase' || 
        //     a.display === 'achievement' ||
        //     a.display === 'prizepack'
        // )
        setActivityToDisplay([...avail]);
    }, [gameActivity])

    useEffect(() => {
        console.log(gameData);
        if (!gameData) return;
        if (!gameData.orgId) return;
        if (gameData.orgId === 'none') return;

        // getGameManagers();
    }, [gameData])

    

    return (
        <div className='manager-activity-list'>
            <div className='manager-activity-content g-card'>
                <BackButton cancel={() => navigate(-1)} />
                <div className='g-space-1'></div>
                <div className='card-title'>
                    <FontAwesomeIcon icon={faGlobeAmericas} />
                    Game Activity
                </div>
                <hr />
                <DetailedActivityList
                    gameData={gameData}
                    activity={activityToDisplay}
                    playerList={playerList}
                    gameElements={gameElements}
                    manager={true}
                    gameManagers={gameManagers}
                />
            </div>
        </div>
    )

}

export default ManagerActivityList  